// extracted by css-extract-rspack-plugin
export default {"container":"container_XeR5M","footer":"footer_NDhCm","header":"header_zQ0ov","close":"close_ZUnhP","title":"title_boe_O","main":"main_QRpnX"};